export const OTEL_TRACE_PATH = '/v1/traces';
export const OTEL_LOGS_PATH = '/v1/logs';
export const OTEL_METRICS_PATH = '/v1/metrics';
export const OTEL_SCHEDULED_DELAY_MS = 1000;
export const OTEL_METRICS_EXPORT_INTERVAL_MS = 60_000;
